/**
 * CameraController - Handles main camera setup
 * Note: Minimap is now handled by HTMLMinimap component
 */
import Phaser from 'phaser';
import { Player } from '../entities/Player';
import { TILE_SIZE } from '../config/game.config';

export interface CameraConfig {
    mazeWidth: number;
    mazeHeight: number;
    isMobile: boolean;
}

export class CameraController {
    private scene: Phaser.Scene;

    constructor(scene: Phaser.Scene) {
        this.scene = scene;
    }

    /**
     * Set up the main camera to follow a player
     */
    setupMainCamera(player: Player, config: CameraConfig): void {
        const cameraZoom = config.isMobile ? 2.0 : 1.5;

        // Set physics world bounds to match the actual maze dimensions
        const mazePixelWidth = config.mazeWidth * TILE_SIZE;
        const mazePixelHeight = config.mazeHeight * TILE_SIZE;
        this.scene.physics.world.setBounds(0, 0, mazePixelWidth, mazePixelHeight);

        // Apply zoom to main camera
        this.scene.cameras.main.setZoom(cameraZoom);

        // Follow player with lerp for smooth "dragging on a string" effect
        this.scene.cameras.main.startFollow(player, true, 0.08, 0.08);
    }

    /**
     * Clean up resources
     */
    destroy(): void {
        // Nothing to clean up - minimap is now handled by HTMLMinimap
    }
}

